export const parsePostData = (postData) => {
  {
    const foo = {
      temaid: null,
      NomeTema: null,
      datapostagem: "/Date(1727977580853)/",
      visivel: "S",
      gestor_restritor: 0,
      nome_gestor_restritor: null,
      fotoGestorRestritor: "FA_1_52.jpg",
      data_ultima_postagem: "/Date(1727977580853)/",
      repostado_por: null,
      total_paginas: 15,
    };
    var type = "";
    if (postData.Link_Capa && type == "") {
      type = "IMAGE";
    }
    return {
      postId: postData.postagemid,
      type,
      title: postData.titulo,
      thumbnailPicture: postData.Link_Capa,
      content:
        postData.carrossel ||
        postData.texto ||
        postData.Link_URL ||
        postData.Link_Doc ||
        postData.Link_youtube,
      reactions: {
        likes: postData.qtd_likes,
        commentaries: postData.qtd_comentario,
        reposts: postData.qtd_repost,
        likedByUser: !!postData.liked_from_me,
      },
      authorData: {
        studentId: postData.alunoid,
        pictureURL: postData.fotoAluno,
        name: postData.nomeAluno,
      },
    };
  }
};
